<template>
	<div class="info">
		<div class="img">
			<img v-if="image" :src="image.url"/>
			<v-img v-else v-bind="require('@/assets/contact/no-person.jpg')"/>
		</div>

		<div class="content">
			<div class="box">
				<div class="title">Kontaktperson</div>
				<div class="name" v-html="name"/>

				<a class="link" :href="_phone.link">
					<div class="icon" v-html="require('@/assets/icons/phone.svg')"/>
					<div class="text" v-text="_phone.text"/>
				</a>
				<a class="link" :href="_email.link">
					<div class="icon" v-html="require('@/assets/icons/envelope-solid.svg')"/>
					<div class="text" v-text="_email.text"/>
				</a>
			</div>
			<div class="box">
				<router-link :to="{name: 'contact'}" class="more">
					Se mere kontaktinfo
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		image: {type: Object, required: false},
		name: {type: String, required: true},
		phone: {type: String, required: true},
		email: {type: String, required: true}
	},
	computed: {
		_phone: (t) => ({
			text: t.phone,
			link: `tel:${t.phone.split(' ').join('')}`
		}),

		_email: (t) => ({
			text: t.email,
			link: `mail:${t.email}`
		})
	}
};
</script>

<style lang="scss" scoped>
.info {
	flex-shrink: 0;
	width: 288px;
	background-color: $white1;

	@include res(tablet) {
		width: 100%;
		display: flex;
		height: 330px;
	}

	@include res(mobile) {
		flex-direction: column;
		height: auto;
	}

	.img {
		img {
			display: block;
			width: 100%;
			height: 292px;
			object-fit: cover;

			@include res(tablet) {
				height: 100%;
				max-height: 530px;
			}
		}
	}

	.content {
		@include res(tablet) {
			flex-shrink: 0;
			width: 50%;
		}

		@include res(mobile) {
			width: 100%;
		}

		.box {
			padding: 47px 40px;

			&:first-child {
				border-bottom: 1px solid #F5F5F5;
			}

			&:last-child {
				@include res(mobile) {
					display: none;
				}
			}

			.title {
				color: #B1B1B1;
				font-size: 12px;
				text-transform: uppercase;
				margin-bottom: 12px;

				@include res(mobile) {
					display: none;
				}
			}

			.name {
				font-size: 17px;
				font-weight: 600;
				margin-bottom: 30px;
				letter-spacing: 0.08px;
			}

			.link {
				display: flex;
				font-size: 14px;
				font-weight: 300;
				color: #22313A;
				margin-bottom: 8px;

				@include res(mobile) {
					color: #B1B1B1;
					font-size: 16px;
				}

				.icon {
					margin-right: 10px;

					/deep/ svg {
						$s: 14px;
						width: $s;
						height: $s;

						path {
							fill: #B1B1B1;
						}
					}
				}
			}

			.more {
				color: #22313A;
				font-size: 14px;
				font-style: italic;
				text-decoration: underline;
			}
		}
	}
}
</style>
